import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-effects.tsx
/**
* icon.16.effects
*
* lightning bolt, zap, effects, magic, spark, flash, special
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNSAyYTEgMSAwIDAgMSAuODQ4IDEuNTNMOS44MDQgNkgxMS41YTEgMSAwIDAgMSAuNzA3IDEuNzA3bC02IDZhMSAxIDAgMCAxLTEuNjQzLTEuMDU5TDUuNTU3IDEwSDRhMSAxIDAgMCAxLS44OTQtMS40NDdsMy02IC4wNzItLjEyMUExIDEgMCAwIDEgNyAyek00IDloM2wtMS41IDQgNi02SDhsMi41LTRIN3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=20730-54168
*/
const Icon16Effects = memo(function Icon16Effects(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M10.5 2a1 1 0 0 1 .848 1.53L9.804 6H11.5a1 1 0 0 1 .707 1.707l-6 6a1 1 0 0 1-1.643-1.059L5.557 10H4a1 1 0 0 1-.894-1.447l3-6 .072-.121A1 1 0 0 1 7 2zM4 9h3l-1.5 4 6-6H8l2.5-4H7z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16Effects };

//# sourceMappingURL=icon-16-effects.js.map